/** Brand marks served from public/, copied from the legacy app's wwwroot/root/Images. */

/** Full-color mark — use on light surfaces. */
export const LOGO_SRC = '/images/Rawam-logo-reporting.png'

/** All-white mark — use on brand-colored surfaces. */
export const LOGO_ON_BRAND_SRC = '/images/Rawam-logo-with-text2.png'
